import React, { useEffect, useRef, useState } from 'react'
import SimpleBlockContent from '../../../../SimpleBlockContent'
import styles from './styles.module.css'
import Text from '../../../../Text'

const cx = (...c) => c.filter(Boolean).join(' ')

function Description({ overrideDescription, description }) {
  const descriptionRef = useRef(null)
  const descriptionCopyRef = useRef(null)

  const [expanded, setExpanded] = useState(false)
  const [isDescriptionLong, setIsDescriptionLong] = useState(false)

  // Re-measure whenever the description CONTENT changes — not just on mount. The
  // description arrives after mount via the client offer refetch (the grid-capped
  // SSR payload drops long descriptions, task #76), so a mount-only measurement
  // (stable-ref deps) sees an empty description, leaves isDescriptionLong=false,
  // and the "Continue reading" toggle never appears — the copy stays clamped with
  // no way to expand (e.g. the Keyboard & Mouse Tray). Depending on the actual
  // content re-runs the measurement once the offer lands.
  useEffect(() => {
    setIsDescriptionLong(
      !!(descriptionCopyRef
        && descriptionCopyRef.current
        && descriptionRef
        && descriptionRef.current
        && descriptionCopyRef.current.offsetHeight > descriptionRef.current.offsetHeight)
    )
  }, [description, overrideDescription])

  const renderDescription = () => {
    return <>
      { overrideDescription && <><SimpleBlockContent blocks={overrideDescription} applySpace/></> }
      { description && !overrideDescription && description.split('\n').filter(d => !!d).map((d, i) => <Text type="regular" key={'description-' + i}>{d}</Text>) }
    </>
  }

  return (
    <div className={styles.wrapper}>
      <div ref={descriptionRef} className={cx(styles.descriptionWrapper, !expanded && styles.descriptionWrapperClamp)}>
        {renderDescription()}
      </div>
      {
        // CLS-by-construction (#139/#90 class): the "Continue reading" toggle only
        // becomes visible AFTER the client measures whether the copy overflows the
        // 4-line clamp (isDescriptionLong flips in the effect above, post-hydration).
        // Rendering it conditionally meant the toggle INSERTED itself after first
        // paint and push-shifted the mobile carousel + buy box below it — the sole
        // remaining product-page shift (~0.013 CLS, measured; the carousel box is
        // already reserved). Fix: reserve the toggle's line box from FIRST PAINT
        // (SSR) whenever the description is clamped, and only toggle the TEXT's
        // visibility once we know it's long. The reserved element carries the real
        // "Continue reading" Text (just `visibility:hidden` until long), so the
        // reserved height EXACTLY matches the shown height — zero reflow on reveal,
        // no magic-number min-height. SSR + first client render agree (isDescription
        // Long starts false), so there is no hydration mismatch. `expanded` is a
        // user action (hadRecentInput) → its reflow is excluded from CLS, so the
        // slot is only reserved in the clamped (!expanded) state.
        !expanded && !!(description || overrideDescription) && (
          <div
            className={styles.ctaWrapper}
            style={{ visibility: isDescriptionLong ? 'visible' : 'hidden' }}
            aria-hidden={!isDescriptionLong}
            onClick={isDescriptionLong ? () => setExpanded(true) : undefined}
          >
            <Text type="regular">Continue reading</Text>
          </div>
        )
      }
      <div ref={descriptionCopyRef} className={cx(styles.descriptionWrapper, styles.descriptionWrapperHide)}>
        {renderDescription()}
      </div>
    </div>
  )
}

export default Description
